var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "lock_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#lock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.005 14.4a6.25 6.25 0 0 1-2.488-.5 6.453 6.453 0 0 1-2.042-1.375A6.462 6.462 0 0 1 2.1 10.486 6.23 6.23 0 0 1 1.6 8h1.2c0 .711.136 1.384.408 2.018a5.224 5.224 0 0 0 2.773 2.774 5.037 5.037 0 0 0 2.016.408c1.446 0 2.675-.506 3.686-1.517C12.694 10.673 13.2 9.444 13.2 8s-.505-2.672-1.517-3.683C10.673 3.306 9.445 2.8 8 2.8a5.06 5.06 0 0 0-2.533.65 5.177 5.177 0 0 0-1.85 1.75H5.2v1.2H1.6V2.8h1.2v1.467a6.545 6.545 0 0 1 2.235-1.942A6.174 6.174 0 0 1 8 1.6c.889 0 1.72.167 2.492.5A6.477 6.477 0 0 1 13.9 5.512c.333.775.5 1.603.5 2.483 0 .881-.167 1.71-.5 2.488a6.451 6.451 0 0 1-3.412 3.417c-.775.333-1.602.5-2.483.5Zm-1.2-4a.589.589 0 0 1-.43-.172A.575.575 0 0 1 6.2 9.8V8.004a.58.58 0 0 1 .173-.427.582.582 0 0 1 .428-.173v-.601c0-.331.118-.614.354-.85.235-.235.518-.353.85-.353.33 0 .612.117.846.352.234.235.351.518.351.848v.6c.17 0 .312.057.426.172A.582.582 0 0 1 9.8 8v1.8c0 .17-.057.313-.172.427a.58.58 0 0 1-.427.173H6.805Zm.595-3h1.2v-.597a.589.589 0 0 0-.171-.428.571.571 0 0 0-.425-.175.587.587 0 0 0-.429.172.576.576 0 0 0-.175.428v.6Z",
    fill: "#404040"
  }))));
};
export default SvgLock;